<div class="modal-overlay" [class.active]="isOpen" (click)="closePanel()"></div>

<div class="file-modal" [class.open]="isOpen">
  <div class="modal-header">
    <h3>{{ isClassificationMode ? 'Classification Review' : 'File Details' }}</h3>
    <button class="close-btn" (click)="closePanel()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>
  
  <div class="modal-content">
    <!-- Loading state -->
    <div *ngIf="loading" class="loading-state">
      <div class="spinner"></div>
      <p>Loading file details...</p>
    </div>
    
    <!-- Error state -->
    <div *ngIf="error" class="error-state">
      <div class="error-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <p>{{ error }}</p>
    </div>
    
    <!-- File details -->
    <div *ngIf="file && !loading && !error" class="file-details">
      <div class="file-header">
        <div class="file-icon" [ngSwitch]="file.extension">
          <!-- PDF Icon -->
          <svg *ngSwitchCase="'pdf'" class="file-red" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="40" height="40" stroke-width="2"> <path d="M14 3v4a1 1 0 0 0 1 1h4"></path> <path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"></path> <path d="M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6"></path> <path d="M17 18h2"></path> <path d="M20 15h-3v6"></path> <path d="M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"></path> </svg> 
          <!-- CSV Icon -->
          <svg *ngSwitchCase="'csv'" class="file-green" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="40" height="40" stroke-width="2"><path d="M14 3v4a1 1 0 0 0 1 1h4"></path><path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"></path><path d="M7 16.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0"></path><path d="M10 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75"></path><path d="M16 15l2 6l2 -6"></path></svg>
          <!-- TXT Icon -->
          <svg *ngSwitchCase="'txt'" class="file-orange" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="40" height="40" stroke-width="2"> <path d="M14 3v4a1 1 0 0 0 1 1h4"></path> <path d="M14 3v4a1 1 0 0 0 1 1h4"></path> <path d="M16.5 15h3"></path> <path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"></path> <path d="M4.5 15h3"></path> <path d="M6 15v6"></path> <path d="M18 15v6"></path> <path d="M10 15l4 6"></path> <path d="M10 21l4 -6"></path> </svg> 
          <!-- PNG Icon -->
          <svg *ngSwitchCase="'png'" class="file-purple" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="40" height="40" stroke-width="2"><path d="M14 3v4a1 1 0 0 0 1 1h4"></path><path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"></path><path d="M20 15h-1a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h1v-3"></path><path d="M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6"></path><path d="M11 21v-6l3 6v-6"></path></svg>
          <!-- DOCX Icon -->
          <svg *ngSwitchCase="'docx'" class="file-blue" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="40" height="40" stroke-width="2"><path d="M14 3v4a1 1 0 0 0 1 1h4"></path><path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2"></path><path d="M9 12l1.333 5l1.667 -4l1.667 4l1.333 -5"></path></svg>
          <svg *ngSwitchCase="'doc'" class="file-blue" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="40" height="40" stroke-width="2"><path d="M14 3v4a1 1 0 0 0 1 1h4"></path><path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2"></path><path d="M9 12l1.333 5l1.667 -4l1.667 4l1.333 -5"></path></svg>
          <!-- XLSX Icon -->
          <svg *ngSwitchCase="'xlsx'" class="file-green" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="40" height="40" stroke-width="2"><path d="M14 3v4a1 1 0 0 0 1 1h4"></path><path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"></path><path d="M10 21l-2 -8l-2 8"></path><path d="M14 16l4 0"></path><path d="M14 19l4 0"></path><path d="M16 16l0 6"></path></svg>
          <svg *ngSwitchCase="'xls'" class="file-green" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="40" height="40" stroke-width="2"><path d="M14 3v4a1 1 0 0 0 1 1h4"></path><path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"></path><path d="M10 21l-2 -8l-2 8"></path><path d="M14 16l4 0"></path><path d="M14 19l4 0"></path><path d="M16 16l0 6"></path></svg>
          <!-- JPG/JPEG Icon -->
          <svg *ngSwitchCase="'jpg'" class="file-purple" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="40" height="40" stroke-width="2"><path d="M14 3v4a1 1 0 0 0 1 1h4"></path><path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"></path><path d="M20 15h-1a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h1v-3"></path><path d="M5 15h3v6h-3"></path><path d="M10 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"></path></svg>
          <svg *ngSwitchCase="'jpeg'" class="file-purple" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="40" height="40" stroke-width="2"><path d="M14 3v4a1 1 0 0 0 1 1h4"></path><path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"></path><path d="M20 15h-1a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h1v-3"></path><path d="M5 15h3v6h-3"></path><path d="M10 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"></path></svg>
          
          <!-- Default Icon -->
          <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M14 3v4a1 1 0 0 0 1 1h4" />
            <path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-4" />
          </svg>
        </div>
        <div class="file-title">
          <h2>{{ file.generatedFileName }}</h2>
          <p class="original-file-name">
            <span>Uploaded as: </span>
            <span class="text-primary">{{ file.originalFileName }}</span>
          </p>
        </div>
      </div>
      <div class="detail-sections">
        <!-- Main details section -->
        <section class="detail-section">
          <h4>File Information</h4>
          <div class="detail-grid">
            
            <!-- File ID -->
            <div class="detail-item">
              <span class="label">File ID</span>  
              <span class="value">{{ file.fileId }}</span>
            </div>
            
            <!-- Category -->
            <div class="detail-item">
              <span class="label">Category</span>

              <span class="value" *ngIf="!isEditing">{{ displayCategory(file.categoryId) || 'N/A' }}</span>

              <select *ngIf="isEditing && canEditCategoryType"
                      class="input"
                      [(ngModel)]="editModel.categoryId"
                      (ngModelChange)="onCategoryChange()">
                <option [ngValue]="null">-- choose --</option>
                <option *ngFor="let c of categoryOptions" [ngValue]="c.id">
                  {{ prettyCategory(c.label) }}
                </option>
              </select>

              <span class="value" *ngIf="isEditing && !canEditCategoryType">
                {{ displayCategory(editModel.categoryId) || 'N/A' }}
              </span>
            </div>

            <!-- Uploaded Date -->
            <div class="detail-item">
              <span class="label">Uploaded</span>
              <span class="value">{{ formatDate(file.uploadedAt) }}</span>
            </div>
            
            <!-- Type -->
            <div class="detail-item">
              <span class="label">Type</span>

              <span class="value" *ngIf="!isEditing">
                {{ displayType(file.typeId) || 'N/A' }}
              </span>

              <select *ngIf="isEditing && canEditCategoryType"
                      class="input"
                      [(ngModel)]="editModel.typeId"
                      (ngModelChange)="onEditChange()">
                <option [ngValue]="null">-- choose --</option>
                <option *ngFor="let t of typeOptions" [ngValue]="t.id">{{ t.label }}</option>
              </select>

              <span class="value" *ngIf="isEditing && !canEditCategoryType">
                {{ displayType(editModel.typeId) || 'N/A' }}
              </span>
            </div>
          </div>
        </section>
        
        <!-- Document details section -->
        <section class="detail-section">
          <h4>Document Details</h4>
          <div class="detail-grid">
            
            <!-- Owner -->
            <div class="detail-item">
              <span class="label">Owner</span>

              <!-- View mode -->
              <span class="value" *ngIf="!isEditing">{{ file.owner || 'N/A' }}</span>
              <!-- Edit mode -->
              <input *ngIf="isEditing"
                      class="input"
                      type="text"
                      [(ngModel)]="editModel.owner"
                      (ngModelChange)="onEditChange()"
                      placeholder="Owner" />
            </div>

            <!-- Issuer -->
            <div class="detail-item">
              <span class="label">Issuer</span>

              <!-- View mode -->
              <span class="value" *ngIf="!isEditing">{{ file.issuer || 'N/A' }}</span>
              <!-- Edit mode -->
              <input *ngIf="isEditing"
                      class="input"
                      type="text"
                      [(ngModel)]="editModel.issuer"
                      (ngModelChange)="onEditChange()"
                      placeholder="Issuer" />
            </div>

            <!-- Document Date -->
            <div class="detail-item">
              <span class="label">Document Date</span>

              <!-- View mode -->
              <span *ngIf="!isEditing" class="value">
                {{ file.documentDate ? (file.documentDate | date:'longDate') : 'N/A' }}
              </span>
              <!-- Edit mode -->
              <input *ngIf="isEditing"
                      type="date"
                      class="input"
                      [ngModel]="editModel.documentDate"
                      (ngModelChange)="editModel.documentDate = $event; onEditChange()"
                      placeholder="Document Date" />
            </div>

            <!-- Tax Year -->
            <div class="detail-item">
              <span class="label">Tax Year</span>

              <!-- View mode -->
              <span class="value" *ngIf="!isEditing">{{ file.taxYear || 'N/A' }}</span>
              <!-- Edit mode -->
              <input *ngIf="isEditing"
                      class="input"
                      type="text"
                      maxlength="4"
                      pattern="\\d{4}"
                      [(ngModel)]="editModel.taxYear"
                      (ngModelChange)="onEditChange()"
                      placeholder="YYYY" />
            </div>
            
          </div>
        </section>

        <section class="detail-section">
          <h4>Additional Details</h4>

          <!-- View mode -->
          <div class="detail-item full-width" *ngIf="!isEditing">
            <p class="detail-text">{{ file.detail || '—' }}</p>
          </div>

          <!-- Edit mode -->
          <div class="detail-item full-width" *ngIf="isEditing">
            <textarea class="input"
                      rows="3"
                      [(ngModel)]="editModel.detail"
                      (ngModelChange)="onEditChange()"
                      placeholder="Add more details..."></textarea>
          </div>
        </section>

      </div>
      
      
      <!-- Action buttons -->
      <div class="action-buttons">
        <!-- Classification Review Mode Buttons -->
        <ng-container *ngIf="isClassificationMode">
          <button class="btn btn-secondary"
                  (click)="viewFile()"
                  [disabled]="viewLoading">
            <svg *ngIf="!viewLoading" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            <svg *ngIf="viewLoading" class="spinner-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 12a9 9 0 11-6.219-8.56"/>
            </svg>
            {{ viewLoading ? 'Loading...' : 'View File' }}
          </button>
          <button class="btn btn-danger" (click)="closePanel()">
            Cancel
          </button>
          <button class="btn btn-success"
                  [disabled]="saving"
                  (click)="save()">
            {{ saving ? 'Approving…' : 'Approve Classification' }}
          </button>
        </ng-container>

        <!-- Folders Mode Buttons (existing) -->
        <ng-container *ngIf="!isClassificationMode">
          <button class="btn btn-primary" (click)="downloadFile()" >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            Download
          </button>
          <button class="btn btn-secondary"
                  (click)="viewFile()"
                  [disabled]="viewLoading">
            <svg *ngIf="!viewLoading" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            <svg *ngIf="viewLoading" class="spinner-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 12a9 9 0 11-6.219-8.56"/>
            </svg>
            {{ viewLoading ? 'Loading...' : 'View' }}
          </button>
          <button
            *ngIf="!isEditing"
            class="btn btn-secondary"
            (click)="startEdit()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
            Edit Details
          </button>
          <!-- Edit mode: Cancel + Save -->
          <button *ngIf="isEditing"
                  class="btn btn-secondary"
                  (click)="cancelEdit()">
            Cancel
          </button>

          <button *ngIf="isEditing"
                  class="btn btn-success"
                  [disabled]="saving || !hasChanges()"
                  (click)="save()">
            {{ saving ? 'Saving…' : 'Save' }}
          </button>
        </ng-container>
      </div>
    </div>
    
    <!-- No file selected state -->
    <div *ngIf="!fileId && !loading && !error" class="no-file-selected">
      <div class="empty-state-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
          <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
          <polyline points="13 2 13 9 20 9"></polyline>
        </svg>
      </div>
      <p>No file selected</p>
      <p class="hint-text">Select a file from the list to view its details</p>
    </div>
  </div>
</div>
